import React, { PropsWithChildren, useEffect, useState } from 'react'
import ExpandableItemHeader, { ExpandableItemHeaderProps } from '@Components/Navigations/Sidebar/ExpandableItemHeader'
import clsx from 'clsx'
import './index.scss'

const ExpandableItem = (
    props: PropsWithChildren<Omit<ExpandableItemHeaderProps, 'onClick' | 'isExpanded'>> & {
        key?: string
        defaultExpanded?: boolean
        persistExpandedState?: boolean
    }
) => {
    const { className, defaultExpanded = true, persistExpandedState = true, ...headerProps } = props
    const isExpandable = props.children !== undefined
    const [isExpanded, setIsExpanded] = useState(() => {
        if (!persistExpandedState) {
            return defaultExpanded
        }

        const storedValue = localStorage.getItem(props.heading)
        return storedValue ? JSON.parse(storedValue) : defaultExpanded
    })
    useEffect(() => {
        if (persistExpandedState && isExpanded !== null && typeof isExpanded !== 'undefined') {
            localStorage.setItem(props.heading, JSON.stringify(isExpanded))
        }
    }, [isExpanded, persistExpandedState, props.heading])

    return (
        <div className={clsx('expandable-item', className)}>
            {isExpandable ? (
                <>
                    <ExpandableItemHeader
                        {...headerProps}
                        onClick={() => {
                            setIsExpanded(!isExpanded)
                        }}
                        isExpanded={isExpanded}
                    />
                    <div className={clsx('expandable-item-sub', isExpanded && 'expanded')}>{props.children}</div>
                </>
            ) : (
                <ExpandableItemHeader {...headerProps} />
            )}
        </div>
    )
}

export default ExpandableItem
